const style = (theme) => {
  const output = {
    root: {
      height: '100vh',
      color: theme.colors[0],
      background: theme.colors[7],
    },
    wrapper: {
      extend: theme.wrapper,
    },
    hero: {
      position: 'relative',
      zIndex: 2,
      boxShadow: `0px 0px 10px 1px ${theme.getRgba(theme.colors[0], 0.2)}`,
      '& p': {
        color: theme.colors[5],
      },
    },
    viewport: {
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
    },
    storeLocatorMap: {
      width: '100%',
      height: '100%',
      position: 'relative',
      zIndex: 1,
      flex: 1,
    },
    stickyBar: {
      background: theme.colors[4],
      color: theme.colors[1],
      width: '100vw',
      position: 'fixed',
      zIndex: 1,
      bottom: 0,
      transform: 'translateY(100%)',
      boxShadow: `0px 0px 1px 1px ${theme.getRgba(theme.colors[0], 0.1)}`,
      transition: `transform 0.8s ${theme.easings['power4.out']}`,
    },
    stickyBarVisible: {
      transform: 'translateY(0)',
    },
    stickyBarContainer: {
      margin: '0 auto',
      paddingTop: 10,
      paddingBottom: 10,
    },
    stickyBarWrapper: {
      extend: theme.wrapper,
      position: 'relative',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '& strong': {
        whiteSpace: 'nowrap',
        fontSize: 16,
      },
      '& p': {
        marginBottom: 0,
        lineHeight: 1,
      },
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {}

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {}

  return output
}

export default style
